import { Package } from "lucide-react";
import React from "react";
import { ApiPackagingSummary } from "../../../../types/prodcut-data-review/product-data.types";
import PackagingDetailPanel from "./components/PackagingDetailPanel";
import { GateKind } from "./types/packagingDetail.types";
import EmptyRow from "../shared/components/EmptyRow";

interface PackagingRecordsListProps {
  packagings: ApiPackagingSummary[];
  gateId: string;
  gateKind: GateKind;
  disabled?: boolean;
}

const PackagingRecordsList: React.FC<PackagingRecordsListProps> = ({
  packagings,
  gateId,
  gateKind,
  disabled = false
}) => {
  if (packagings.length === 0) return <EmptyRow label="packagings" />;

  return (
    <div className="tw-space-y-2">
      {packagings.map(pkg => (
        <div key={pkg._id} className="tw-border tw-rounded-md tw-overflow-hidden">
          <div className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-bg-muted/40 tw-border-b">
            <Package className="tw-h-3.5 tw-w-3.5 tw-text-primary" />
            <span className="tw-text-sm tw-font-medium">{pkg.packagingName || "—"}</span>
          </div>

          <div className="tw-p-3">
            <PackagingDetailPanel packaging={pkg} gateId={gateId} gateKind={gateKind} disabled={disabled} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default PackagingRecordsList;
